import { render, staticRenderFns } from "./DashboardNegociacao.vue?vue&type=template&id=07daa004&scoped=true&lang=html&"
import script from "./DashboardNegociacao.vue?vue&type=script&lang=js&"
export * from "./DashboardNegociacao.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNegociacao.vue?vue&type=style&index=0&id=07daa004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07daa004",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardNegociacao.vue
// module id = 1195
// module chunks = 28